import {
  EXTERNAL_ID_FIELD,
  STRING_FIELD,
  STRING_OPTIONS,
  TIMESTAMP_FIELD,
} from "utils/react-lib/generic-ui/firestoreFields";

export const MARKDOWN_DOC_TYPE = "markdown";
export const CODE_DOC_TYPE = "code";

export const markdownDocumentSchema = {
  "mdDocuments/{id}": (buildData) => ({
    _fieldOrder: ["name", "type", "content"],
    content: STRING_FIELD("Content"),
    createdAt: TIMESTAMP_FIELD("Created At"),
    name: STRING_FIELD("Name"),
    type: STRING_OPTIONS("Type", [
      { label: "Markdown", value: MARKDOWN_DOC_TYPE },
      { label: "Code", value: CODE_DOC_TYPE },
    ]),
    uid: EXTERNAL_ID_FIELD("User Id", buildData),
  }),
  "documents/{id}": (buildData) => ({
    _fieldOrder: ["name"],
    createdAt: TIMESTAMP_FIELD("Created At"),
    name: STRING_FIELD("Name"),
    uid: EXTERNAL_ID_FIELD("User Id", buildData),
  }),
  
};
